import { ValidationProvider, ValidationObserver } from "vee-validate/dist/vee-validate.full.esm";
import Autenticado from "@/views/Templates/Autenticado/Autenticado.vue";
import DgoContainer from "@/components/DGOContainer/DGOContainer.vue";
import DgoRow from "@/components/DGORow/DGORow.vue";
import DgoCol from "@/components/DGOCol/DGOCol.vue";
import { mapActions, mapState, mapMutations } from "vuex";
import { arrHasAnyEqualVal } from "@/helpers/helpers";

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        DgoContainer,
        DgoRow,
        DgoCol,
        Autenticado,
    },
    data() {
        return {
            form: {
                old_password: '',
                new_password: '',
            }
        };
    },
    computed: {
        ...mapState('change-pass', {
            loadingResetPass: 'loading',
            successResetPass: 'success',
            errorResetPass: 'error',
        }),
    },
    methods: {
        ...mapActions('change-pass', ['requestNewPass']),
        ...mapMutations('change-pass', ['setResetPass']),
        async onSubmit() {
            this.setResetPass(this.form);
            const password = await this.requestNewPass();
            
            if (password) {
                this.$router.push('/arquivos');
            } else {
                const hasFieldsError = arrHasAnyEqualVal(this.form, this.errorResetPass);
                if (hasFieldsError) { this.$refs.form.setErrors(this.errorResetPass); }
            }
        }
    },
}
